import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDateString } from "../../../common/date";
import CustomStore from "devextreme/data/custom_store";

export default function Comment(props) {
  const { commentPopupVisible, setCommentPopupVisible, cTaskCategory } = props;

  const userInfo = useSelector((state) => state.userInfo);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    if (cTaskCategory) {
      setDataSource(
        new CustomStore({
          key: ["SEQ"],
          load: async () => {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/comment/${cTaskCategory.quotNo}/${cTaskCategory.codeNo}`
            );

            return result.data;
          },

          insert: async (values) => {
            await axios.post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/comment/${cTaskCategory.quotNo}/${cTaskCategory.codeNo}`,
              values
            );
          },
          update: async (key, values) => {
            await axios.put(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/comment/${cTaskCategory.quotNo}/${cTaskCategory.codeNo}/${key.SEQ}`,
              values
            );
          },
          remove: async (key) => {
            await axios.delete(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/comment/${cTaskCategory.quotNo}/${cTaskCategory.codeNo}/${key.SEQ}`
            );
          },
        })
      );
    }
  }, [cTaskCategory]);

  const onHiding = () => {
    setCommentPopupVisible(false);
  };

  const calculateCellValue = (data) => {
    if (data) {
      return `${data.name} (${data.commentator})`;
    } else {
      return null;
    }
  };

  const disabled = (e) => {
    if (e.row.data.commentator == userInfo.employeeNo) {
      return false;
    } else {
      return true;
    }
  };

  const onInitNewRow = (e) => {
    e.data.commentator = userInfo.employeeNo;
    e.data.name = userInfo.name;
    e.data.date = getDateString(new Date());
  };

  return (
    <Popup
      visible={commentPopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={true}
      showCloseButton={true}
      showTitle={true}
      title="Comment"
      height={"auto"}
      onHiding={onHiding}
    >
      <DataGrid
        dataSource={dataSource}
        key={"SEQ"}
        showBorders={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"100%"}
        style={{ maxHeight: "calc(100vh - 145px)" }}
        repaintChangesOnly={true}
        highlightChanges={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        onInitNewRow={onInitNewRow}
      >
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <LoadPanel enabled={true} />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />
        <Selection mode={"single"} />

        <Editing
          mode={"batch"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
          selectTextOnEditStart={true}
          startEditAction={"dblClick"}
        />

        <Column
          dataField={"commentator"}
          caption={"Commentator"}
          width={135}
          calculateCellValue={calculateCellValue}
          allowEditing={false}
        />
        <Column
          dataField={"date"}
          caption={"Date"}
          width={95}
          format={"yyyy-MM-dd"}
          dataType={"date"}
          allowEditing={false}
        />
        <Column
          dataField={"comment"}
          caption={"Comment"}
          showEditorAlways={true}
        />
        <Column type={"buttons"}>
          <Button name={"delete"} disabled={disabled} />
        </Column>
      </DataGrid>
    </Popup>
  );
}
